import moment from 'moment'

export const DISCOUNT_TYPE = {
  PERCENTAGE: 'percentage',
  FIXED_AMOUNT: 'fixed_amount',
}

export const DISCOUNT_TYPE_LABEL = [
  {
    value: DISCOUNT_TYPE.PERCENTAGE,
    label: 'Percentage Discount (%)',
  },
  {
    value: DISCOUNT_TYPE.FIXED_AMOUNT,
    label: 'Fixed Amount Discount ($)',
  },
]

export const FREQUENCY = {
  REPEATING: 'repeating',
  ONCEONLY: 'once_only',
  REPEATING_INDEFINITE: 'repeating_indefinite',
}

export const DURATION = {
  NO_END_DATE: 'no_end',
  END_DATE: 'end',
}

export const PRODUCT_TYPE = {
  ALL: 'all',
  SPECIFIC: 'specific',
  BRAND: 'brand',
  CATEGORY: 'category',
}

export const CUSTOMER_TYPE = {
  ALL: 'all',
  REGISTERED: 'registered',
  SPECIFIC: 'specific',
}

export const CUSTOMER_TYPE_LIST = [
  {
    value: CUSTOMER_TYPE.SPECIFIC,
    label: 'Specific Customers',
  },
  {
    value: CUSTOMER_TYPE.REGISTERED,
    label: 'Registered Customers',
  },
  {
    value: CUSTOMER_TYPE.ALL,
    label: 'All Customers',
  },
]

export const DEFAULT_PROMOTION_FORM = {
  allProducts: {
    discountAmount: 0,
    discountType: DISCOUNT_TYPE.PERCENTAGE,
  },
  globalDiscount: {
    discountAmount: 0,
    discountType: DISCOUNT_TYPE.PERCENTAGE,
  },
  name: '',
  description: '',
  discountType: DISCOUNT_TYPE.PERCENTAGE,
  discountAmount: 0,
  duration: DURATION.NO_END_DATE,
  startDate: '',
  endDate: '',
  productType: PRODUCT_TYPE.SPECIFIC,
  frequency: FREQUENCY.ONCEONLY,
  days: [0],
  startTime: '',
  endTime: moment('23:45', 'HH:mm').format('hh:mm A'),
  cbxGlobal: false,
  discount: '',
  demo: '',
  products: {},
  categories: {},
  brands: {},
  customerType: CUSTOMER_TYPE.ALL,
  customers: {},
  note: '',
  color: '',
}

export const FREQUENCY_VALUE = [
  {
    value: FREQUENCY.ONCEONLY,
    label: 'Just Once',
  },
  {
    value: FREQUENCY.REPEATING,
    label: 'Repeating',
  },
  {
    value: FREQUENCY.REPEATING_INDEFINITE,
    label: 'Repeating Indefinite',
  },
]

export const DURATION_VALUE = [
  {
    value: DURATION.NO_END_DATE,
    label: 'No End Date',
  },
  {
    value: DURATION.END_DATE,
    label: 'Set An End Date',
  },
]

export const STATUS = {
  WAITING: 'waiting',
  ACTIVE: 'active',
  ENDING: 'ending',
  ENDED: 'ended',
  DRAFT: 'draft',
}

export const STATUS_VALUES = {
  DRAFT: -1,
  WAITING: 0,
  ACTIVE: 1,
  ENDING: 2,
  ENDED: 3,
}

export const STATUS_VALUE = [
  {
    value: STATUS.WAITING,
    label: 'Scheduled',
  },
  {
    value: STATUS.ACTIVE,
    label: 'Ongoing',
  },
  {
    value: STATUS.ENDING,
    label: 'Finishing',
  },
  {
    value: STATUS.ENDED,
    label: 'Finished',
  },
  {
    value: STATUS.DRAFT,
    label: 'Draft',
  },
]

export const PRODUCT_TYPE_LABEL = {
  [PRODUCT_TYPE.ALL]: 'All Products Discount',
  [PRODUCT_TYPE.SPECIFIC]: 'Specific Products Discount',
  [PRODUCT_TYPE.BRAND]: 'Products From Brands Discount',
  [PRODUCT_TYPE.CATEGORY]: 'Products From Categories Discount',
}

export const PROMOTION_DETAIL_TABS = {
  ALL: 'all',
  SPECIFIC: 'specific',
  BRAND: 'brand',
  CATEGORY: 'category',
}

export const CHANGELOG_TYPE = {
  NAME: 'name',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  FREQUENCY: 'frequency',
  REPEATING_DAYS: 'repeating_days',
  START_TIME: 'start_time',
  END_TIME: 'end_time',
  GLOBAL_DISCOUNT: 'global_discount',
  PRODUCT_TYPE: 'product_type',
  ALL_PRODUCTS: 'all_products',
  PRODUCTS: 'products',
  BRANDS: 'brands',
  CATEGORIES: 'categories',
  CREATED: 'created',
  DUPLICATED: 'duplicated',
  ENDED: 'ended',
  COMPLETED: 'completed',
  NOTE_ADDED: 'note_added',
  BULK_QUANTITY: 'bundle_bulk_quantity_discount',
  BUNDLE_DISCOUNT: 'bundle_discount',
  BOGO_BUY_X_GET_X: 'bogo_buy_x_get_x',
  BOGO_BUY_X_GET_Y: 'bogo_buy_x_get_y',
}

export const CHANGELOG_LABEL = {
  [CHANGELOG_TYPE.NAME]: 'Name was updated',
  [CHANGELOG_TYPE.START_DATE]: 'Begins date was updated',
  [CHANGELOG_TYPE.END_DATE]: 'Ends date was updated',
  [CHANGELOG_TYPE.FREQUENCY]: 'Frequency was updated',
  [CHANGELOG_TYPE.REPEATING_DAYS]: 'Repeating days was updated',
  [CHANGELOG_TYPE.START_TIME]: 'Start time was updated',
  [CHANGELOG_TYPE.END_TIME]: 'End time was updated',
  [CHANGELOG_TYPE.GLOBAL_DISCOUNT]: 'Global discount value was updated',
  [CHANGELOG_TYPE.PRODUCT_TYPE]: 'Discount type was updated',
  [CHANGELOG_TYPE.ALL_PRODUCTS]: 'Discount value on all products was updated',
  [CHANGELOG_TYPE.PRODUCTS]: 'Discount products was updated',
  [CHANGELOG_TYPE.BRANDS]: 'Discount brands was updated',
  [CHANGELOG_TYPE.CATEGORIES]: 'Discount categories was updated',
  [CHANGELOG_TYPE.CREATED]: 'Promotion was created',
  [CHANGELOG_TYPE.DUPLICATED]: 'Promotion was duplicated from ',
  [CHANGELOG_TYPE.ENDED]: 'Promotion was ended',
  [CHANGELOG_TYPE.COMPLETED]: 'Promotion completed',
  [CHANGELOG_TYPE.NOTE_ADDED]: 'Note Added:',
  [CHANGELOG_TYPE.BULK_QUANTITY]: 'Bulk quantity discount was updated',
  [CHANGELOG_TYPE.BUNDLE_DISCOUNT]: 'Bundle discount was updated',
  [CHANGELOG_TYPE.BOGO_BUY_X_GET_X]: 'Buy X get X promotion was updated',
  [CHANGELOG_TYPE.BOGO_BUY_X_GET_Y]: 'Buy X get Y promotion was updated',
}

/** New Promotion constants */
export const PROMOTION_TABS = {
  CALENDAR: 'calendar',
  LIST: 'list',
  CREATE: 'create',
  EDIT: 'edit',
}

export const PROMOTION_ACTIONS = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
}

export const PROMOTION_STATUS = {
  DRAFT: 'draft',
  SCHEDULE: STATUS.WAITING,
  ONGOING: STATUS.ACTIVE,
  FINISHING: STATUS.ENDING,
  FINISHED: STATUS.ENDED,
}

export const PROMOTION_STATUS_VALUE = [
  {
    value: PROMOTION_STATUS.DRAFT,
    label: 'Draft',
  },
  {
    value: PROMOTION_STATUS.SCHEDULE,
    label: 'Schedule',
  },
  {
    value: PROMOTION_STATUS.ONGOING,
    label: 'Ongoing',
  },
  {
    value: PROMOTION_STATUS.FINISHING,
    label: 'Finishing',
  },
  {
    value: PROMOTION_STATUS.FINISHED,
    label: 'Finished',
  },
]

export const All_LOCATION = 'all'

export const PROMOTION_DATE_FORMAT = 'MM/DD/YYYY'
export const PROMOTION_PERFORMANCE_DATE_FORMAT = 'YYYY-MM-DD'

export const APPLIED_LOCATIONS_VALUE = {
  ALL: 'all',
  SPECIFIC: 'specific',
}

export const APPLIED_LOCATIONS_LIST = [
  {
    value: APPLIED_LOCATIONS_VALUE.ALL,
    label: 'All Locations',
  },
  {
    value: APPLIED_LOCATIONS_VALUE.SPECIFIC,
    label: 'Specific Locations',
  },
]

export const BANNER_TYPE = {
  NO_BANNER: 'no_banner',
  FOOTER: 'footer',
  CAROUSEL: 'carousel',
  HERO_BANNER: 'hero_banner',
  WIDE_BANNER: 'wide_banner',
  NARROW_BANNER: 'narrow_banner',
}

export const BANNER_POSITION = {
  HOME_PAGE: 'home_page',
  CATEGORIES: 'categories',
  PRODUCT_PAGE: 'product_page',
}

export const BANNER_TYPE_OPTION = [
  {
    value: `${BANNER_POSITION.HOME_PAGE}_${BANNER_TYPE.HERO_BANNER}`,
    label: 'Home Page - Hero Banner',
  },
  {
    value: `${BANNER_POSITION.HOME_PAGE}_${BANNER_TYPE.CAROUSEL}`,
    label: 'Home Page - Carousel',
  },
  // {
  //   value: `${BANNER_POSITION.HOME_PAGE}_${BANNER_TYPE.FOOTER}`,
  //   label: 'Home Page - Footer',
  // },
  // {
  //   value: `${BANNER_POSITION.CATEGORIES}_${BANNER_TYPE.HERO_BANNER}`,
  //   label: 'Categories - Hero Banner',
  // },
  // {
  //   value: `${BANNER_POSITION.PRODUCT_PAGE}_${BANNER_TYPE.WIDE_BANNER}`,
  //   label: 'Product Page - Wide Banner',
  // },
  // {
  //   value: `${BANNER_POSITION.PRODUCT_PAGE}_${BANNER_TYPE.NARROW_BANNER}`,
  //   label: 'Product Page - Narrow Banner',
  // },
]

export const BANNER_DISPLAY_VALUE = {
  FIRST: 'first',
  LAST: 'last',
}

export const BANNER_DISPLAY_OPTIONS = [
  {
    value: BANNER_DISPLAY_VALUE.FIRST,
    label: 'First banner on the carousel',
  },
  {
    value: BANNER_DISPLAY_VALUE.LAST,
    label: 'Last banner on the carousel',
  },
]
